import ArchiveSeasonStandingsDb from "./ArchiveSeasonStandingsDb.jsx";

export default function ArchiveSeasonStandingsIntDb() {
    return (
        <ArchiveSeasonStandingsDb
            scopeType="DRIVER"
            classKey="INT"
            title="Archiv Standings INT"
            pillLabel="INT"
        />
    );
}
